/* eslint-disable webflow/no-delete */
import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const defaults = {
    style: 'roadmap',
    zoom: '12',
    tooltip: '',
    latlng: '',
  };

  if (!data.attr) {
    data.attr = {};
  }

  const needsMigration =
    jsonNode.type === 'MapWidget' &&
    (!data.attr.hasOwnProperty('data-enable-scroll') ||
      !data.attr.hasOwnProperty('data-enable-touch'));

  return {
    needed: needsMigration,
    logData: {
      msg: 'MapWidget data should be converted to Data Type',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // create data-enable-scroll
      if (data.widget.hasOwnProperty('scrollwheel')) {
        data.attr['data-enable-scroll'] = data.widget.scrollwheel;
      } else {
        data.attr['data-enable-scroll'] =
          data.attr['data-disable-scroll'] !== '1';
      }

      // create data-enable-touch
      if (data.widget.hasOwnProperty('enableTouch')) {
        data.attr['data-enable-touch'] = data.widget.enableTouch;
      } else {
        data.attr['data-enable-touch'] =
          data.attr['data-disable-touch'] !== '1';
      }

      // handle not existing address
      if (!data.widget.hasOwnProperty('address')) {
        data.widget.address = '';
      }

      // move latlng
      data.attr['data-widget-latlng'] =
        data.widget.latLng ||
        data.attr['data-widget-latlng'] ||
        defaults.latlng;

      // move tooltip
      data.attr['data-widget-tooltip'] =
        data.widget.tooltip ||
        data.attr['data-widget-tooltip'] ||
        defaults.tooltip;

      // move style
      data.attr['data-widget-style'] =
        data.widget.style || data.attr['data-widget-style'] || defaults.style;

      // move zoom change from string to number
      data.attr['data-widget-zoom'] = Number(
        String(data.widget.zoom) ||
          data.attr['data-widget-zoom'] ||
          defaults.zoom
      );

      delete data.widget.style;
      delete data.widget.latLng;
      delete data.widget.enableTouch;
      delete data.widget.scrollwheel;
      delete data.widget.tooltip;
      delete data.widget.zoom;
      delete data.children;
    },
  };
};
